import { HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { GTMHUB_ADDITIONAL_PARAMS } from "@webapp/core/http/interceptors/track-data.interceptor";
import { Observable } from "rxjs";
import { Comments, CommentsDTO } from "../models/comments.models";
import { CommentsApiService } from "./comments-api.service";
import { CommentsState } from "./comments-state.service";

@Injectable({
  providedIn: "any",
})
export class CommentsFacade extends BaseFacade<Comments, CommentsDTO, CommentsState, CommentsApiService> {
  constructor(state: CommentsState, api: CommentsApiService) {
    super(state, api);
  }

  public postComment$(comment: Partial<Comments>): Observable<Comments> {
    const gtmhubAdditionalParams = { hasGif: !!comment.gif?.id };
    const requestConfig = {
      ...new RequestConfig(),
      context: new HttpContext().set(GTMHUB_ADDITIONAL_PARAMS, gtmhubAdditionalParams),
    };

    return this.apiService.post$<Comments>(comment, requestConfig);
  }

  public edit$(id: string, comment: Partial<Comments>, gifChanges: { isDeleted: boolean; isAdded: boolean }): Observable<Comments> {
    const isGifEdited = gifChanges.isAdded || gifChanges.isDeleted;
    const gtmhubAdditionalParams = isGifEdited
      ? {
          gifEdited: gifChanges.isAdded ? "added" : "deleted",
        }
      : {};
    const requestConfig = {
      ...new RequestConfig(),
      context: new HttpContext().set(GTMHUB_ADDITIONAL_PARAMS, gtmhubAdditionalParams),
    };

    return this.apiService.put$(id, comment, requestConfig);
  }
}
